import MuiButtonBase from '@mui/material/ButtonBase';
import patchButtonBaseComponent from './patch-base-button-components';
export const ButtonBase = patchButtonBaseComponent(MuiButtonBase);
